import React, { useEffect } from "react"
import ReactDOM from "react-dom"
import { IOneTimeReminder } from "./types"
import { ReminderComponentProxy } from "./ReminderComponentProxy"

/**
 * Use this component to render one time reminder below top toolbar area
 */

export const OneTimeReminder = (props: IOneTimeReminder) => {
  useEffect(() => {
    const element = document.getElementById("one-time-reminder")
    
    ReactDOM.render(
      // @ts-ignore
      React.createElement(ReminderComponentProxy, { ...props }),
      element
    )
    
    return () => {
      ReactDOM.unmountComponentAtNode(element as HTMLElement)
    }
  }, [])
  
  return <></>
}